import * as tslib_1 from "tslib";
import { ActionTypeEnum } from '@core/components/fc-tree-view/fc-tree.types';
import { sortArchivedThenByName } from '@core/utils/sort-archived-then-by-name';
import { TranslateService } from '@ngx-translate/core';
import { chain, clone } from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
var CreateRecurrenceLinkLogsService = /** @class */ (function () {
    function CreateRecurrenceLinkLogsService(translateService) {
        var _this = this;
        this.translateService = translateService;
        this.generateLinks = function (snapshot) {
            var equipments = clone(snapshot.equipments || []);
            var unlinkedEquipments = equipments.filter(function (eq) { return !eq.locationSector && !eq.locationEnvironment; }).sort(sortArchivedThenByName);
            var environments = chain(snapshot.locationEnvironments || [])
                .concat(equipments.filter(function (eq) { return eq.locationEnvironment; }).map(function (equipment) { return (tslib_1.__assign({}, equipment.locationEnvironment, { locationSector: equipment.locationSector })); }))
                .map(function (environment) { return (tslib_1.__assign({}, environment, { equipments: equipments.filter(function (eq) { return eq.locationEnvironment && eq.locationEnvironment.id === environment.id; }).sort(sortArchivedThenByName) })); })
                .uniqBy('id')
                .value();
            var sectors = chain(snapshot.locationSectors || [])
                .concat((snapshot.locationEnvironments || []).map(function (environment) { return environment.locationSector; }))
                .concat(equipments.filter(function (eq) { return eq.locationSector; }).map(function (equipment) { return equipment.locationSector; }))
                .map(function (sector) { return (tslib_1.__assign({}, sector, { locationEnvironments: environments.filter(function (env) { return env.locationSector.id === sector.id; }).sort(sortArchivedThenByName), equipments: equipments.filter(function (eq) { return eq.locationSector && eq.locationSector.id === sector.id && !eq.locationEnvironment; }).sort(sortArchivedThenByName) })); })
                .uniqBy('id')
                .sort(sortArchivedThenByName)
                .value();
            return {
                sectors: _this.formatSectors(sectors),
                equipmentsWithoutSector: _this.formatUnlinkedEquipments(unlinkedEquipments),
            };
        };
    }
    CreateRecurrenceLinkLogsService.prototype.formatSectors = function (sectors) {
        var _this = this;
        return (sectors || []).map(function (sector) {
            var sectorItem = {
                id: sector.id,
                text: sector.name,
                description: sector.description,
                icon: 'sector',
                metadata: 'sector',
                archived: sector.archived,
                archivedText: _this.translateService.instant('RECURRENCES.DIALOG.TABS.HISTORIC.ARCHIVED'),
                action: {
                    type: ActionTypeEnum.none,
                }
            };
            sectorItem.children = tslib_1.__spread(_this.formatEnvironments(sector.locationEnvironments), _this.formatEquipments(sector.equipments));
            return sectorItem;
        });
    };
    CreateRecurrenceLinkLogsService.prototype.formatUnlinkedEquipments = function (unlinkedEquipments) {
        var formattedEquipments = this.formatEquipments(unlinkedEquipments);
        if (!formattedEquipments.length) {
            return [];
        }
        return [{
                text: this.translateService.instant('RECURRENCES.DIALOG.TABS.TAB_LINKS.EQUIPMENTS_WITHOUT_SECTOR_ENVIRONMENT'),
                icon: 'more_vertical',
                children: formattedEquipments,
                action: {
                    type: ActionTypeEnum.none
                }
            }];
    };
    CreateRecurrenceLinkLogsService.prototype.formatEnvironments = function (environments) {
        var _this = this;
        return (environments || []).map(function (environment) {
            var environmentItem = {
                id: environment.id,
                text: environment.name,
                description: environment.description,
                icon: 'environment',
                archived: environment.archived,
                archivedText: _this.translateService.instant('RECURRENCES.DIALOG.TABS.HISTORIC.ARCHIVED'),
                metadata: 'environment',
                action: {
                    type: ActionTypeEnum.none
                }
            };
            environmentItem.children = _this.formatEquipments(environment.equipments);
            return environmentItem;
        });
    };
    CreateRecurrenceLinkLogsService.prototype.formatEquipments = function (equipments) {
        var _this = this;
        return (equipments || []).map(function (equipment) { return ({
            id: equipment.id,
            text: equipment.name,
            description: equipment.number,
            archived: equipment.archived,
            archivedText: _this.translateService.instant('RECURRENCES.DIALOG.TABS.HISTORIC.ARCHIVED'),
            icon: 'equipment',
            image: equipment.imageUrl,
            children: [],
            metadata: 'equipment',
            action: {
                type: ActionTypeEnum.none
            }
        }); });
    };
    CreateRecurrenceLinkLogsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CreateRecurrenceLinkLogsService_Factory() { return new CreateRecurrenceLinkLogsService(i0.ɵɵinject(i1.TranslateService)); }, token: CreateRecurrenceLinkLogsService, providedIn: "root" });
    return CreateRecurrenceLinkLogsService;
}());
export { CreateRecurrenceLinkLogsService };
